module.exports = __webpack_public_path__ + "static/media/pending-outer.1e5f537b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pending-outer.svg
// module id = ./src/assets/images/pending-outer.svg
// module chunks = 0